import type { DefaultTheme } from "styled-components/dist/types";
import { colors } from "./ui";

export const lightTheme: DefaultTheme = {
    active: colors.alabaster.active,
    activeContrast: colors.alabaster.background,
    backgroundColor: colors.brand.white,
    buttonHover: colors.brand.purple,
    font: "Avantt-Regular,sans-serif",
    sidebarBackground: "#F7F7F7",
    navigationBackGround: "#F7F5FF",
    navigationFrame: "#E5E1F8",
    navigationIcon: colors.alabaster.grey,
    navigationText: colors.tufte.black,
    previewPageNumber: colors.brand.purple,
    previewPageNumberBackground: colors.brand.white,
    red: colors.alabaster.red,
    white: colors.brand.white,
    sideBarText: colors.tufte.black,
    stacksHeaderBackGround: "#F8F7FB",
    stacksRollOverBackground: "#F0EDFC",
    topBarBackGround: colors.brand.purple,
    topBarButtonHover: colors.brand.yellow,
    authButtonTheme: {
        background: colors.brand.black,
        borderBlockEnd: 1,
        borderInlineEnd: 1,
        borderInlineStart: 1,
        borderBlockStart: 1,
        borderColor: colors.yellow,
        color: colors.brand.yellow,
        fontSize: 1.2, // rem - base font size is 1rem
        height: 3, // rem - base font size is 1rem
        width: "90%", // this may be tricky
        hoverColor: colors.brand.purple,
        minWidth: { landscape: "20vw", portrait: "60vw" },
    }
}